import { render, staticRenderFns } from "./NavBarPromoButton.vue?vue&type=template&id=12775394&scoped=true&"
import script from "./NavBarPromoButton.vue?vue&type=script&lang=js&"
export * from "./NavBarPromoButton.vue?vue&type=script&lang=js&"
import style0 from "./NavBarPromoButton.vue?vue&type=style&index=0&id=12775394&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12775394",
  null
  
)

export default component.exports